<template>
    <v-row>
        <v-col
            sm="12"
            md="8"
            offset-md="2"
        >
            <v-card>
                <v-card-title class="primary--text">
                    Cadastro de RCA
                </v-card-title>
                <v-card-text>
                    <v-form
                        ref="form"
                        @submit.prevent="enviarSolicitacao"
                    >
                        <v-text-field
                            v-model="form.EMPRESA"
                            outlined
                            label="Nome da Empresa"
                            :rules="[$rules.required]"
                            maxlength="100"
                        />

                        <v-text-field
                            v-model="form.ENDERECO"
                            outlined
                            label="Endereço"
                            :rules="[$rules.required]"
                            maxlength="100"
                        />

                        <v-select
                            v-model="form.ESTADO"
                            outlined
                            label="Estado"
                            :items="estadosList"
                            :rules="[$rules.required]"
                            maxlength="2"
                        />

                        <v-select
                            v-model="form.CIDADE"
                            outlined
                            label="Cidade"
                            :items="municipiosList"
                            item-value="NOME"
                            item-text="NOME"
                            :rules="[$rules.required]"
                            no-data-text="Selecione um Estado"
                            maxlength="100"
                        />

                        <v-row>
                            <v-col
                                class="py-0"
                                cols="12"
                                sm="6"
                            >
                                <v-text-field
                                    v-model="form.TELEFONE_CELULAR"
                                    v-mask="['(##) ####-####', '(##) #####-####']"
                                    outlined
                                    label="Telefone Celular"
                                    :rules="[$rules.required]"
                                    maxlength="15"
                                />
                            </v-col>
                            <v-col
                                class="py-0"
                                cols="12"
                                sm="6"
                            >
                                <v-text-field
                                    v-model="form.TELEFONE_FIXO"
                                    v-mask="['(##) ####-####', '(##) #####-####']"
                                    outlined
                                    label="Telefone Fixo"
                                    maxlength="15"
                                />
                            </v-col>
                        </v-row>

                        <v-text-field
                            v-model="form.RESPONSAVEL_COMERCIAL"
                            outlined
                            label="Responsável Comercial"
                            :rules="[$rules.required]"
                            maxlength="100"
                        />

                        <v-textarea
                            v-model="form.MARCAS_REPRESENTADAS"
                            outlined
                            label="Marcas Representadas (separadas por vírgula)"
                            :rules="[$rules.required]"
                            rows="3"
                            maxlength="100"
                        />

                        <v-text-field
                            v-model="form.REGIAO_ATUACAO"
                            outlined
                            label="Região de Atuação"
                            :rules="[$rules.required]"
                            maxlength="100"
                        />

                        <v-file-input
                            v-model="form.FILE_CURRICULUM_APRESENTACAO"
                            outlined
                            label="Currículo / Apresentação"
                            prepend-icon="mdi-file-outline"
                            show-size
                            :accept="$root.config.FILE_ALLOWED_EXTENSIONS"
                            :rules="[$rules.required, $rules.fileSize($root.config.FILE_MAX_SIZE), $rules.fileExtension($root.config.FILE_ALLOWED_EXTENSIONS)]"
                        />

                        <v-layout justify-center>
                            <v-btn
                                color="primary"
                                type="submit"
                            >
                                Enviar Solicitação
                            </v-btn>
                        </v-layout>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import api from '../../services/api';

    export default {
        data() {
            return {
                form: {
                    EMPRESA: null,
                    ENDERECO: null,
                    CIDADE: null,
                    ESTADO: null,
                    TELEFONE_CELULAR: null,
                    TELEFONE_FIXO: null,
                    RESPONSAVEL_COMERCIAL: null,
                    MARCAS_REPRESENTADAS: null,
                    REGIAO_ATUACAO: null,
                    FILE_CURRICULUM_APRESENTACAO: null
                },

                estadosList: [
                    { text: 'Acre (AC)', value: 'AC' },
                    { text: 'Alagoas (AL)', value: 'AL' },
                    { text: 'Amapá (AP)', value: 'AP' },
                    { text: 'Amazonas (AM)', value: 'AM' },
                    { text: 'Bahia (BA)', value: 'BA' },
                    { text: 'Ceará (CE)', value: 'CE' },
                    { text: 'Distrito Federal (DF)', value: 'DF' },
                    { text: 'Espírito Santo (ES)', value: 'ES' },
                    { text: 'Goiás (GO)', value: 'GO' },
                    { text: 'Maranhão (MA)', value: 'MA' },
                    { text: 'Mato Grosso (MT)', value: 'MT' },
                    { text: 'Mato Grosso do Sul (MS)', value: 'MS' },
                    { text: 'Minas Gerais (MG)', value: 'MG' },
                    { text: 'Pará (PA)', value: 'PA' },
                    { text: 'Paraíba (PB)', value: 'PB' },
                    { text: 'Paraná (PR)', value: 'PR' },
                    { text: 'Pernambuco (PE)', value: 'PE' },
                    { text: 'Piauí (PI)', value: 'PI' },
                    { text: 'Rio de Janeiro (RJ)', value: 'RJ' },
                    { text: 'Rio Grande do Norte (RN)', value: 'RN' },
                    { text: 'Rio Grande do Sul (RS)', value: 'RS' },
                    { text: 'Rondônia (RO)', value: 'RO' },
                    { text: 'Roraima (RR)', value: 'RR' },
                    { text: 'Santa Catarina (SC)', value: 'SC' },
                    { text: 'São Paulo (SP)', value: 'SP' },
                    { text: 'Sergipe (SE)', value: 'SE' },
                    { text: 'Tocantins (TO)', value: 'TO' }
                ],

                municipiosList: []
            };
        },

        watch: {
            'form.ESTADO'(value) {
                if (value) {
                    this.fetchMunicipios(value);
                } else {
                    this.municipiosList = [];
                }
            }
        },

        methods: {
            async fetchMunicipios() {
                try {
                    const response = await api.getMunicipiosByUF(this.form.ESTADO);

                    this.municipiosList = response.data;
                } catch (error) {}
            },

            async enviarSolicitacao() {
                try {
                    if (this.$refs.form.validate()) {
                        await api.saveCadastroRCA(this.form);

                        this.$refs.form.reset();

                        this.$root.$emit('message', { text: 'Cadastro realizado com sucesso!', color: 'success' });
                    }
                } catch (error) {
                    let message = 'Erro ao salvar o cadastro.';

                    if (error.response && error.response.data && error.response.data.message) {
                        message = error.response.data.message;
                    }

                    this.$root.$emit('message', { text: message, color: 'error' });
                }
            }
        }
    };
</script>